"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderByCusotmerEnum = exports.CustomerFamilyStatusEnum = void 0;
var CustomerFamilyStatusEnum;
(function (CustomerFamilyStatusEnum) {
    CustomerFamilyStatusEnum["DEPENDENT"] = "dependent";
    CustomerFamilyStatusEnum["INDEPENDENT"] = "independent";
    CustomerFamilyStatusEnum["PRIMARY"] = "primary";
})(CustomerFamilyStatusEnum = exports.CustomerFamilyStatusEnum || (exports.CustomerFamilyStatusEnum = {}));
var OrderByCusotmerEnum;
(function (OrderByCusotmerEnum) {
    OrderByCusotmerEnum["ID"] = "id";
    OrderByCusotmerEnum["CUSTOMER_TYPES"] = "customerTypes";
    OrderByCusotmerEnum["FIRST_NAME"] = "firstName";
    OrderByCusotmerEnum["LAST_NAME"] = "lastName";
    OrderByCusotmerEnum["EMAIL"] = "email";
    OrderByCusotmerEnum["STATUS"] = "status";
    OrderByCusotmerEnum["COLOR_CODE_ID"] = "colorCodeId";
})(OrderByCusotmerEnum = exports.OrderByCusotmerEnum || (exports.OrderByCusotmerEnum = {}));
//# sourceMappingURL=enums.js.map